import styled, { css } from 'styled-components'
import { breakpoint, size } from '../layout/styles'

interface DividerContent {
  title: string;
  description: string;
}

export const DividerShapeBanner = ({title, description}: DividerContent) => {
  return (
    <Section>
      <TopSection>
        <Heading>{title || 'Where To Buy'}</Heading>
        <p>{description || ''}</p>
      </TopSection>
    </Section>
  )
}

const Section = styled.section`
  padding-top: 0;
  padding-bottom: 0;
  @media ${breakpoint.desktop}{
    padding-top: 0;
  }
`

const TopSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  min-height: 15rem;
  background-color: var(--divider-background);
  position: relative;
  box-sizing: border-box;
  padding: 3rem;
  margin-bottom: 0;
  
  @media ${breakpoint.tablet} {
    padding: 3rem 10rem;
  }
  
  p {
    color: var(--divider-description);
    text-align: center;
    margin: 2rem 0 0 0;
    
    @media ${breakpoint.tablet} {
      margin: 2rem 0 0;
    }
  }
`;

const Heading = styled.h1`
  font-size: 1.5rem;
  color: var(--divider-title);
  text-align: center;
  
  @media ${breakpoint.tablet} {
    font-size: 2.25rem;
  }
`